<template>
	<div class="teacher_component">
		<div class="teacher_header flex bg_white">
			<div class="teacher_header_l flex">
				<img :src="public.top_logo" />
				<span class="f20px">·&nbsp;&nbsp;&nbsp;&nbsp;教师端</span>
			</div>
			<div class="teacher_header_r tc f16px flex">
				<router-link to="/" class="logon_header_list cl_dark">
					<img src="../../static/icon_index.png" />
					<p>返回首页</p>
				</router-link>
				<div class="logon_header_list cl_dark cur" @click="signOut">
					<img src="../../static/icon_sign.png" />
					<p>退出登录</p>
				</div>
			</div>
		</div>
		<div class="teacher_nav bg_white">
			<div class="teacher_nav_info tc">
				<img :src="myInfo.avatar" class="radius" />
				<p class="cl_violet f12px mat10">你好，
					<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) < 0">{{myInfo.real_name}}</span>
					<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) > 0 && [null,''].indexOf(myInfo.name) < 0">{{myInfo.name}}</span>
					<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) > 0 && [null,''].indexOf(myInfo.name) > 0">{{myInfo.wx_nickname}}</span>
				</p>
			</div>
			<div class="teacher_nav_cont">
				<div class="news_nav_list" v-for="(item,index) in nav" :key="index" :class="[{'on':item.id==current.navCur},{'open':item.id==current.open}]">
					<div class="news_nav_list_title flex f20px cl_dark" v-if="item.senior_info_two_cate" @click="navCheck(item.id)">
						<div class="news_nav_list_title_l flex">
							<img :src="item.icon" class="mar15" />
							<span>{{item.name}}</span>
						</div>
					</div>
					<router-link :to="item.url" class="news_nav_list_title flex f20px cl_dark" v-else>
						<div class="news_nav_list_title_l flex">
							<img :src="item.icon" class="mar15" />
							<span>{{item.name}}</span>
						</div>
					</router-link>
					<ul class="news_nav_list_cont f18px cl_gray" v-if="item.senior_info_two_cate">
						<li class="news_nav_list_item" v-for="item in item.senior_info_two_cate" :key="item.id" :class="{'on':item.id==current.listCur}">
							<router-link :to="item.url" class="block">{{item.name}}</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'teacher_nav',
	  props: {
	    current: {
	    	navCur: Number,
	    	listCur: Number,
				open: Number,
	    },
	  },
		data () {
			return {
				myInfo: {},
				public: {},
				nav: [
					{
						id: 1,
						icon: require("../../static/teacher_nav_01.png"),
						name: "班级管理",
						url: "/class_manage",
						open: false,
					},{
						id: 2,
						icon: require("../../static/teacher_nav_02.png"),
						name: "布置作业",
						url: "/task",
						open: false,
					},{
						id: 3,
						icon: require("../../static/teacher_nav_03.png"),
						name: "发布公告",
						url: "/notice",
						open: false,
					},{
						id: 4,
						icon: require("../../static/teacher_nav_04.png"),
						name: "作业记录",
						url: "/record",
						open: false,
					},{
						id: 5,
						icon: require("../../static/teacher_nav_05.png"),
						name: "我的组卷",
						url: "/organize",
						open: false,
					},{
						id: 6,
						icon: require("../../static/teacher_nav_06.png"),
						name: "学校资源库",
						open: false,
						senior_info_two_cate: [
							{
								id: 1,
								name: "视频库",
								url: "/video_my",
							},{
								id: 2,
								name: "试卷库",
								url: "/paper_my",
							},
							{
								id: 3,
								name: "课件",
								url: "/courseware",
							},
						],
					},{
						id: 7,
						icon: require("../../static/teacher_nav_07.png"),
						name: "数据报告",
						open: false,
						senior_info_two_cate: [
							{
								id: 3,
								name: "学生使用报告",
								url: "/student_report",
							},{
								id: 4,
								name: "知识点分析",
								url: "/kno_report",
							},
						],
					},
				],
			}
		},
		mounted() {
			this.getMyInfo();
			this.getInfo();
		},
		methods: {
			//个人信息
			getMyInfo () {
				var that = this;
				that.$get("/api/user/get_user_info",{
					token: localStorage.getItem("token")
				})
				.then(res => {
					that.myInfo = res.data;
					that.$emit("info-event", that.myInfo)
				});
			},
			//基础信息
			getInfo () {
				var that = this;
				that.$get("/api/base/get_base_configuration_data",{})
				.then(res => {
					that.public = res.data;
					that.$emit("public-event", that.public)
				});
			},
			navCheck (e) {
				if (e == this.current.open) {
					this.current.open = "";
				} else {
					this.current.open = e;
				}
			},
			//退出
			signOut () {
				localStorage.removeItem("token");
				this.$router.push({path:'/'})
			},
		},
	}
</script>

<style>
</style>
